// Hooks
import { useGetCurrUser } from 'hooks';

export const useIsOwnProfile = (slug?: string | null): boolean => {
  const { data: currentUserData } = useGetCurrUser();

  if (!currentUserData?.me?.slug || !slug) return false;
  return currentUserData.me.slug === slug;
};
